module.exports = __webpack_public_path__ + "img/img48.d9630864.svg";